import { Platform } from 'react-native';

/**
 * iPhone / iPod Safari shows Apple’s Smart App Banner from `apple-itunes-app`.
 * Hide custom store chrome there only — Android and desktop still get badges.
 */
export function isIosPhoneBrowser(): boolean {
  if (Platform.OS === 'ios') return true;
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPod/.test(navigator.userAgent);
}
